import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import {
  EXPERIMENTAL_FEATURES_STORAGE_KEY,
  isExperimentalFeaturesEnabled,
} from '../utils/experimentalFeatures';

interface ExperimentalFeaturesContextType {
  enabled: boolean;
  toggle: () => void;
}

const ExperimentalFeaturesContext = createContext<ExperimentalFeaturesContextType>({
  enabled: false,
  toggle: () => {},
});

export const useExperimentalFeatures = () => useContext(ExperimentalFeaturesContext);

export const ExperimentalFeaturesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [enabled, setEnabled] = useState<boolean>(() => isExperimentalFeaturesEnabled());

  useEffect(() => {
    localStorage.setItem(EXPERIMENTAL_FEATURES_STORAGE_KEY, enabled.toString());
  }, [enabled]);

  const toggle = useCallback(() => {
    setEnabled(prev => !prev);
  }, []);

  return (
    <ExperimentalFeaturesContext.Provider value={{ enabled, toggle }}>
      {children}
    </ExperimentalFeaturesContext.Provider>
  );
};

export { ExperimentalFeaturesContext };
